var map = {
	"./404.svg": "0143",
	"./add.svg": "76a4",
	"./auction.svg": "9717",
	"./back.svg": "7338",
	"./beauty.svg": "9617",
	"./book.svg": "fc4e",
	"./car.svg": "14cf",
	"./cashgift.svg": "c3a4",
	"./catering.svg": "5f52",
	"./child.svg": "6f31",
	"./cigarette_wine.svg": "9064",
	"./clear.svg": "c8de",
	"./communication.svg": "ac20",
	"./costume.svg": "e527",
	"./dayuse.svg": "0789",
	"./delete.svg": "0d45",
	"./detail.svg": "ddc0",
	"./digital.svg": "6766",
	"./fruits.svg": "f95d",
	"./furniture.svg": "51c2",
	"./gift.svg": "fb5c",
	"./house.svg": "750c",
	"./licai.svg": "3d63",
	"./lottery.svg": "bdc7",
	"./maintain.svg": "f5cf",
	"./medical.svg": "be1c",
	"./movie.svg": "8795",
	"./oldman.svg": "a502",
	"./otherrevenue.svg": "5cef",
	"./parttime.svg": "d5fd",
	"./pet.svg": "ea5a",
	"./recreation.svg": "122a",
	"./remake.svg": "9074",
	"./setting.svg": "5de8",
	"./shopping.svg": "23e8",
	"./snacks.svg": "fa42",
	"./social_contact.svg": "60b8",
	"./sport.svg": "8c4c",
	"./statistics.svg": "8ccb",
	"./study.svg": "975a",
	"./traffic.svg": "2a2a",
	"./transfer_accounts.svg": "6505",
	"./travel.svg": "34dc",
	"./vegetable.svg": "ca25",
	"./wage.svg": "4a58",
	"./work.svg": "fc35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2db";